import styled from 'styled-components';
import { Button } from 'finform';
import { Body } from '#app/components/Text/styles';
import type { ParsedRoboStatus } from '#app/pages/Roboadvisor/utils/roboStatus';
import { formatRebalancingDate, formatStatusValue } from '#app/pages/Roboadvisor/utils/roboStatus';

const StrategyContainer = styled.div`
  background-color: #eff2f5;
  padding: 16px 12px;
  border-radius: 12px;
  max-width: 386px;
  width: 100%;
  margin-bottom: 16px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const Title = styled.h2`
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  margin: 0px;
`;

const Description = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #000;
  margin: 0px;
  ${(props) =>
    props.color &&
    `
    color: ${props.color};
  `}
`;

const StatusDetails = styled.div`
  width: 100%;
  margin-top: 4px;
`;

const StatusRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 0;

  &:not(:last-child) {
    border-bottom: 1px solid #dfe3e8;
  }

  &:last-child {
    padding-bottom: 0;
  }
`;

const StatusLabel = styled(Body)`
  color: #6a7480;
  text-align: left;
  flex: 1;
`;

const StatusValue = styled(Body)`
  text-align: right;
`;

interface StrategyProps {
  title: string;
  description: string;
  onCreate?: () => void;
  createText?: string;
  subTitle?: React.ReactNode;
  statusDetails?: ParsedRoboStatus;
}

const Strategy = ({
  title,
  description,
  onCreate,
  createText = 'Подключить снова',
  subTitle = '',
  statusDetails,
}: StrategyProps) => (
  <StrategyContainer>
    <Column>
      <Title>{title}</Title>
      <Description>{description}</Description>
      {statusDetails ? (
        <StatusDetails>
          <StatusRow>
            <StatusLabel>Сервер подключен</StatusLabel>
            <StatusValue>
              {formatStatusValue(
                statusDetails.executionConnected === true &&
                  statusDetails.rebalanceConnected === true
              )}
            </StatusValue>
          </StatusRow>
          <StatusRow>
            <StatusLabel>Последняя ребалансировка</StatusLabel>
            <StatusValue>{formatRebalancingDate(statusDetails.lastRebalancingTime)}</StatusValue>
          </StatusRow>
        </StatusDetails>
      ) : null}
      {subTitle ? (
        typeof subTitle === 'string' ? (
          <Description color="#EF5E70">{subTitle}</Description>
        ) : (
          subTitle
        )
      ) : null}
    </Column>
    {createText && onCreate && (
      <Button onClick={onCreate} wide={true}>
        {createText}
      </Button>
    )}
  </StrategyContainer>
);

export default Strategy;
